// AbstractTicketTaskForm

export default {
    data() {
      return {
        ticketTaskFormData : null, // 配置
        properties : {} // 值
      };
    },

    methods: {
        listForm() {
          this.ticketTaskFormData = [];
    
          if ( !!this.ticketNo ) {
            this.mode = 'edit';
            this.listUserTaskFormPropertyByTicketNo(this.ticketNo);
            return;
          }
    
          if ( !!this.taskId ) {
            this.mode = 'show';
            this.listHistoryFormPropertyByTaskId(this.taskId);
            return;
          }
    
          if ( !!this.templateId ) {
            this.mode = 'new';
            this.listStartFormPropertyByTemplateId(this.templateId);
            return;
          }
    
          if ( !!this.workflowId ) {
            this.mode = 'new';
            this.listStartFormPropertyByWorkflowId(this.workflowId);
            return;
          }
    
          if ( !!this.ticketNo_2 ) {
            this.mode = 'show';
            this.listFirstFormPropertyByTicketNo(this.ticketNo_2);
            return;
          }
        },

        listHistoryFormPropertyByTaskId(taskId) {
            var _this = this;
    
            sdk.TicketWorkflowApi().listHistoryFormPropertyByTaskId({
              taskId : taskId
            }).then(res => {
              // console.log('#50 listHistoryFormPropertyByTaskId', res);

              if( !!res ) {
                  _this.ticketTaskFormData = res;

                  res.forEach(e => {
                      _this.properties[e.id] = _this.parsePropertyValue(e);
                  });

                  // 变更前的值
                  _this.propertiesBefore = JSON.parse(JSON.stringify(_this.properties));

                  _this.ifHasAllowDeny();
              }
            });
        },

        ifHasAllowDeny() {
          for ( var i = 0; i < this.ticketTaskFormData.length; i++ ) {
            if ( 'allow_deny' == this.ticketTaskFormData[i].type ) {
              this.hasAllowDeny = true;
              break;
            }
          }
        },

        onInput_TicketTaskFormItem() {
          // console.log('#75 onInput_TicketTaskFormItem', this.properties, this);

          this.$emit('input', this.properties);
        },

        onChange_TicketTaskFormItemge( _e, props) {
          _e.taskId = this.taskId;
          _e.fieldValueBefore = this.propertiesBefore[ _e.fieldName ];
    
          // console.log('#86 onChange_TicketTaskFormItemge', this.properties, _e, props, this);
          this.$emit('change', _e, props);
        }
    }
  }


// WEBPACK FOOTER //
// ./src/assets/mixins/AbstractTicketTaskForm.js